export const QR_CODE_PATTERN = /^RD[0-9]+$/;
